import React from 'react';
import styles from './WhereToGetTower.module.scss';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import { HomeSectionTitle } from '../HomeSectionTitle/HomeSectionTitle';
import { TowerAvailableOn } from '.';

import tower_buying_image from '../../assets/imgs/home/img-get-tower-buying.png';
import pte_cdh from '../../assets/imgs/home/img-get-tower-cdh.png';
import pte_tck from '../../assets/imgs/home/img-get-tower-cz.png';
import google_store_btn from '../../assets/imgs/btn_googleplay.png';
import apple_store_btn from '../../assets/imgs/btn_appstore_b.png';
import qr_cdh from '../../assets/imgs/qr_cdh.png';
import qr_ck from '../../assets/imgs/qr_ck.png';

const cdhGpLink = 'https://go.onelink.me/bUzl/9c836b67';
const cdhAppStoreLink = 'https://go.onelink.me/VHLW/e01c1c3f';
const ckAppStoreLink = 'https://playnow.onelink.me/iHDy/89953a36';

const WhereToGetTower = () => {
    const [t] = useTranslation();
    const history = useHistory();

    return (
        <div className={styles.where_to_get_tower} id="getTower">
            <div className={styles.section_title}>
                <HomeSectionTitle title={t('WHERE_TO_GET_TOWER')} />
            </div>

            <div className={styles.section_body}>
                <div className={styles.get_tower_card}>
                    <div
                        className={`${styles.card_body} ${styles.buying_or_swapping}`}
                    >
                        <div className={styles.card_title}>{t('BUY_OR_SWAPPING')}</div>
                        <div className={styles.description}>{t('TOWER_PAIRED_WITH_TOKENS')}</div>
                        <img src={tower_buying_image} alt="Tower Buying" />
                    </div>
                    <div className={styles.card_footer}>
                        <Button
                            variant="cdh-general-blue"
                            className={styles.footer_btn}
                            onClick={() => history.push('/buy-tower/matic')}
                        >
                            {t('GET_TOWER')}
                        </Button>
                    </div>
                </div>

                <div className={styles.get_tower_card}>
                    <div
                        className={`${styles.card_body} ${styles.pte_events_cdh_mobile}`}
                    >
                        <div className={styles.card_title}>{t('PTE_EVENTS_CDH_MOBILE_GAME')}</div>
                        <div className={styles.description}>{t('CDH_GAME_INFO')}</div>
                        <img src={pte_cdh} alt="play-to-earn-cdh" />
                    </div>
                    <div className={styles.card_footer}>
                        <a
                            href={cdhAppStoreLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={apple_store_btn}
                                className={styles.app_store_img}
                                alt="apple-play-btn"
                            />
                        </a>
                        <a
                            href={cdhGpLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={google_store_btn}
                                className={styles.app_store_img}
                                alt="google-play-btn"
                            />
                        </a>
                        <img
                            src={qr_cdh}
                            className={styles.qr_img}
                            alt="cdh-qr"
                        />
                    </div>
                </div>

                <div className={styles.get_tower_card}>
                    <div
                        className={`${styles.card_body} ${styles.pte_events_tck_mobile}`}
                    >
                        <div className={styles.card_title}>{t('PTE_EVENTS_CK_MOBILE_GAME')}</div>
                        <div className={styles.description}>{t('CK_GAME_INFO')}</div>
                        <img src={pte_tck} alt="play-to-earn-tck" />
                    </div>
                    <div className={styles.card_footer}>
                        <a
                            href={ckAppStoreLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={apple_store_btn}
                                className={styles.app_store_img}
                                alt="apple-play-btn"
                            />
                        </a>
                        <img
                            src={qr_ck}
                            className={styles.qr_img}
                            alt="ck-qr"
                        />
                    </div>
                </div>
            </div>
            <TowerAvailableOn />
        </div>
    );
};

export { WhereToGetTower };
